import * as React from 'react';
import { useSelector } from 'react-redux';

import { Breadcrumbs } from '../../components/Breadcrumbs';
import { selectListingBreadcrumbs } from '../../selectors/listingOffers';

export interface IBreadcrumbsContainerProps {
  className?: string;
  onBreadcrumbClick?(): void;
}

export function BreadcrumbsContainer({ className, onBreadcrumbClick }: IBreadcrumbsContainerProps) {
  const breadcrumbs = useSelector(selectListingBreadcrumbs);

  if (!breadcrumbs?.length) {
    return null;
  }

  return <Breadcrumbs breadcrumbs={breadcrumbs} className={className} onBreadcrumbClick={onBreadcrumbClick} />;
}

BreadcrumbsContainer.displayName = 'BreadcrumbsContainer';
